import { useEffect, useState } from 'react'

import { api, type User } from './api'
import { Admin } from './pages/Admin'
import { AppDetail } from './pages/AppDetail'
import { Apps } from './pages/Apps'
import { Auth } from './pages/Auth'

type View = { name: 'apps' } | { name: 'app'; id: string } | { name: 'admin' }

export function App() {
  const [user, setUser] = useState<User | null>(null)
  const [loading, setLoading] = useState(true)
  const [view, setView] = useState<View>({ name: 'apps' })

  useEffect(() => {
    api
      .me()
      .then(setUser)
      .catch(() => setUser(null))
      .finally(() => setLoading(false))
  }, [])

  if (loading) return <div className="page">Загрузка…</div>
  if (!user) return <Auth onReady={setUser} />

  async function logout() {
    await api.logout().catch(() => undefined)
    setUser(null)
  }

  return (
    <>
      <div className="topbar">
        <div className="brand">
          <span className="dot" />
          PushMe
        </div>
        <button className="link" onClick={() => setView({ name: 'apps' })}>
          Приложения
        </button>
        {user.is_superadmin && (
          <button className="link" onClick={() => setView({ name: 'admin' })}>
            Платформа
          </button>
        )}
        <div className="spacer" />
        <span className="who">{user.email}</span>
        <button className="link" onClick={logout}>
          Выйти
        </button>
      </div>

      <div className="page">
        {view.name === 'apps' && <Apps onOpen={(id) => setView({ name: 'app', id })} />}
        {view.name === 'app' && (
          <AppDetail
            appId={view.id}
            onBack={() => setView({ name: 'apps' })}
            onAppIdChanged={(id) => setView({ name: 'app', id })}
          />
        )}
        {view.name === 'admin' && <Admin />}
      </div>
    </>
  )
}
